import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTicket, faUser } from '@fortawesome/free-solid-svg-icons';
import { Link } from "react-router-dom";
import AuthCheck from '../../components/authCheck/AuthCheck';

const ProfileForm = () => {
  const [formData, setFormData] = useState({
    email: "",
    mobile: "",
    firstName: "",
    lastName: "",
    gender: "male",
    picture: "",
    name: ""
  });

  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    if (storedUser) {
      const user = JSON.parse(storedUser);

      // Split the full name into first and last name
      const nameParts = user.name?.split(" ") || [];
      const firstName = nameParts[0] || "";
      const lastName = nameParts.slice(1).join(" ") || "";

      setFormData({
        email: user.email || "",
        mobile: "",
        firstName: firstName,
        lastName: lastName,
        gender: "male",
        picture: "",
        name: user.name || ""
      });
    }
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  return (
    <AuthCheck redirectTo="/">
      <>
        <section className="container-xxl px-md-5 myProfile">
          <div className="row p-md-4">
            {/* Sidebar */}
            <div className="col-md-2 border-end d-none d-md-block">
              <div className="p-3">
                <Link to="/my-bookings" className="btn btn-link w-100 mb-3  border-0">
                  <FontAwesomeIcon icon={faTicket} className="me-2" />
                  My Bookings
                </Link>
                <Link to="/profile" className="btn btn-link active w-100 border-0">
                  <FontAwesomeIcon icon={faUser} className="me-2" />
                  Profile
                </Link>
              </div>
            </div>
            {/* Profile Section */}
            <div className="col-md-8 offset-md-1 mb-4 p-md-4 pt-5">
              <div className="me-3 position-relative d-flex align-items-center">
                {/* <img
                  src={formData.picture}
                  alt="Profile"
                  className="rounded-circle"
                  width="80"
                  height="80"
                /> */}
                <div className="">
                  <p className="mb-0 text-muted">Welcome!</p>
                  <h5 className="mb-0 ">{formData.name}</h5>
                </div>
              </div>
              <hr />

              {/* Account Details */}
              <div className="row mb-4 account-details">
                <h5 className=" mb-3 ">Account Details</h5>
                <div className="col-md-6 mb-3">
                  <label className="form-label">Email Address</label>
                  <div className="d-flex align-items-center position-relative">
                    <input
                      type="email"
                      className="form-control "
                      value={formData.email}
                      disabled
                    />
                    <span className="ms-2 text-success d-flex align-items-center">
                      <svg className="me-1" fill="#00BC10" width={'1rem'} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"/></svg> Verified
                    </span>
                  </div>
                </div>
                {/* <div className="col-md-6 mb-3">
                  <label className="form-label">Mobile Number</label>
                  <div className="input-group">
                    <input
                      type="text"
                      className="form-control"
                      name="mobile"
                      value={formData.mobile}
                      onChange={handleChange}
                    />
                    <button className="btn btn-primary" type="button">
                      Verify
                    </button>
                  </div>
                </div> */}
              </div>

              {/* Personal Details */}
              <h5 className=" mb-3">Personal Details</h5>
              <div className="row mb-3">
                <div className="col-md-6 mb-3">
                  <label className="form-label">Name</label>
                  <input
                    type="text"
                    className="form-control"
                    name="firstName"
                    value={formData.firstName}
                    onChange={handleChange}
                    disabled
                  />
                </div>
                {/* <div className="col-md-6 mb-3">
                  <label className="form-label">Last Name</label>
                  <input
                    type="text"
                    className="form-control"
                    name="lastName"
                    value={formData.lastName}
                    onChange={handleChange}
                    disabled
                  />
                </div> */}
              </div>

              {/* Gender */}
              <div className="mb-4 d-none">
                <label className="form-label d-block">Identity (Optional)</label>
                <div className="d-flex align-items-center pb-3">
                  <div className="form-check form-check-inline d-flex align-items-center">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="gender"
                      id="male"
                      value="male"
                      checked={formData.gender === "male"}
                      onChange={handleChange}
                      disabled
                    />
                    <label className="form-check-label ps-2" htmlFor="male">
                      Male
                    </label>
                  </div>
                  <div className="form-check form-check-inline d-flex align-items-center">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="gender"
                      id="female"
                      value="female"
                      checked={formData.gender === "female"}
                      onChange={handleChange}
                      disabled
                    />
                    <label className="form-check-label ps-2" htmlFor="female">
                      Female
                    </label>
                  </div>
                </div>
              </div>

              {/* Action Buttons */}
              <div className="d-flex justify-content-between d-none">
                <button className="btn btn-secondary">
                  Cancel
                </button>
                <button
                  className="btn px-4 btn-primary"
                >
                  Save Changes
                </button>
              </div>
            </div>
          </div>
        </section>
      </>
    </AuthCheck>
  );
};

export default ProfileForm;
